import store from "~/store";

function isAuthorized(roles, userRoles) {
    let authorized = false;
    if (roles.length === 0) {
        authorized = true;
    }
    roles.forEach(role => {
        if (userRoles.includes(role)) {
            authorized = true;
        }
    });
    return authorized;
}

function isValidUser(user){
    return user && user.groups && user.groups.length > 0;
}


export default async (to, from, next) => {
    if ((!store.getters["auth/check"] && store.getters["auth/access_token"])) {
        try {
            await store.dispatch("auth/fetchUser");
        } catch (e) {
            store.commit("auth/LOGOUT");
            return next({ name: "login" });
        }
    }
    if(!store.getters["auth/appId"] && store.getters["auth/access_token"]){
        await store.dispatch("auth/updateAppId");
    }
    // Check User Role
    let roles = to.meta.roles || [];
    if(
        isValidUser(store.getters["auth/user"]) &&
            !isAuthorized(roles, store.getters["auth/user"]["groups"])
    ){
        store.dispatch('toast/addFixedToasts', {
            header: '¡_warning!',
            body: "you_are_not_authorized_to_access_this_page",
            color: 'warning'
        });
        return next(from);
    }

    return next();
};
